var map = {
	"./body/4x4-active.svg": "a1a9",
	"./body/4x4.svg": "2f82",
	"./body/all-active.svg": "2f22",
	"./body/all.svg": "09a4",
	"./body/chassis-cab-active.svg": "fe25",
	"./body/chassis-cab.svg": "b4ab",
	"./body/combi-van-active.svg": "0f22",
	"./body/combi-van.svg": "ba3a",
	"./body/coupe-active.svg": "36d0",
	"./body/coupe.svg": "7cf4",
	"./body/double-cab-dropside-active.svg": "4869",
	"./body/double-cab-dropside.svg": "3472",
	"./body/double-cab-pick-up-active.svg": "bc91",
	"./body/double-cab-pick-up.svg": "af1f",
	"./body/double-cab-tipper-active.svg": "e39e",
	"./body/double-cab-tipper.svg": "ba2c",
	"./body/double-chassis-cab-active.svg": "9f97",
	"./body/double-chassis-cab.svg": "4e54",
	"./body/dropside-active.svg": "e9db",
	"./body/dropside.svg": "75e1",
	"./body/estate-active.svg": "91ea",
	"./body/estate.svg": "2ebd",
	"./body/extra-high-roof-active.svg": "37bf",
	"./body/extra-high-roof.svg": "338c",
	"./body/hatchback-active.svg": "a3ff",
	"./body/hatchback.svg": "4376",
	"./body/high-roof-window-van-active.svg": "e672",
	"./body/high-roof-window-van.svg": "0f94",
	"./body/high-volume-high-roof-van-active.svg": "74b0",
	"./body/high-volume-high-roof-van.svg": "fcb1",
	"./body/luton-active.svg": "ed61",
	"./body/luton.svg": "3fa0",
	"./body/mpv-active.svg": "262ff",
	"./body/mpv.svg": "8814",
	"./body/saloon-active.svg": "a525",
	"./body/saloon.svg": "a7f6",
	"./body/sports-active.svg": "e20c",
	"./body/sports.svg": "69bb",
	"./body/standard-roof-minibus-active.svg": "6fe9",
	"./body/standard-roof-minibus.svg": "c1fd",
	"./body/tipper-active.svg": "acc0",
	"./body/tipper.svg": "8b8d",
	"./body/van-active.svg": "1e01",
	"./body/van.svg": "28f1",
	"./body/window-van-active.svg": "e55b",
	"./body/window-van.svg": "f1fa",
	"./default-vehicle.svg": "934c",
	"./link-icons/accident-management.svg": "572b",
	"./link-icons/account-management.svg": "c8d0",
	"./link-icons/daily-rental.svg": "f683",
	"./link-icons/driver-ordering-portal.svg": "bc40",
	"./link-icons/my-fleet-pro.svg": "578b",
	"./link-icons/tyres.svg": "5620"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";